/**
 * @class AddTheLookItem
 * @classdesc The Shop the Look section. Displays an image
 *            with interactable points directing customers to featured products.
 * @extends Core.SectionComponent
 */
export default class AddTheLookItem extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);

    this.state = {
      product: this.data.product,
    };
  }

  get optionsSelector() {
    return this.query('options-selector');
  }

  get formData() {
    return new FormData(this.el.querySelector('[data-product-form]'));
  }

  onMount() {
    this.events.register(this.el, 'product:options-change', event => {
      const { variant } = event.detail;

      fetch(`${this.data.product_url}/async?variant=${variant.id}&section_id=${this.data.section_id}`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const detailsEl = html.querySelector('[data-component="product-details"]');

          if (detailsEl) {
            this.el.querySelector('[data-component="product-details"]').replaceWith(detailsEl);
          }
        });
    });
  }
}
